<div class="card">
  <div class="card-body align-middle ">
    <div class="row align-middle">
      <div class="col-lg-2 form-group">
        <label class="mb-0 text-dark">{{'Prodotto' | translate}}</label>
        <input type="text" #prodotto = "ngModel" [(ngModel)]="Filtri.prodotto"  name="prodotto" class="form-control">
      </div>
      <div class="col-lg-2 form-group">
        <label class="mb-0 text-dark">{{'acquisti.inizio' | translate}}</label>
        <input type="date" #inizio = "ngModel" min="{{inizioMese | date:'yyyy-MM-dd'}}" [(ngModel)]="Filtri.inizio"  name="inizio" class="form-control">
      </div>
      <div class="col-lg-2 form-group">
        <label class="mb-0 text-dark">{{'acquisti.fine' | translate}}</label>
        <input type="date" #fine = "ngModel" min="{{inizioMese | date:'yyyy-MM-dd'}}" [(ngModel)]="Filtri.fine" name="fine" class="form-control">
      </div>
      <div class=" mt-3 mt-md-0 d-flex align-items-center p-1">
        <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="refresh()" type="button">Cerca</button>
      </div>
    </div>

  </div>
</div>
<div class="card" style="">
  <div class="card-body align-middle ">
    <div class="table-responsive" style="height: calc(100vh - 330px);">
  <table class="table table-striped table-bordered bg-white table-hover align-middle mb-0 no-wrap" >
    <thead>
      <tr style="background-color: '#e5e5e5'; border: 0.2pt solid grey;">
        <th style=" border: 0.2pt solid grey;">Prodotto</th>
        <th style=" border: 0.2pt solid grey;" [attr.colspan]="scorte?.colonne?.length" *ngFor="let item of scorte?.mesi ?? []"  ><span style="text-align: end; display: block;">{{item}}</span></th>
      </tr>
      <tr style=" border: 0.2pt solid grey;">
        <th style=" border: 0.2pt solid grey;"></th>
        <ng-container *ngFor="let i of scorte?.mesi ?? []" >
          <th style=" border: 0.2pt solid grey;" *ngFor="let item of scorte?.colonne ?? []"> <span style="text-align: end; display: block;">{{item}}</span> </th>
        </ng-container>
      </tr>
    </thead>
    <tbody class="table-striped">
    <tr *ngFor="let item of scorte?.data ?? []" [style.background-color]="item.colore ?? 'transparent'" >
      <td class="align-middle" style="border: 0.2pt solid grey; border-bottom: 0; border-top: 0; border-left: 0; " >
        <span class="d-flex align-items-center">
          {{item.prodotto}}
        </span>
      </td>
      <ng-container *ngFor="let i of item?.dati ?? []" >
        <td  *ngFor="let val of i ?? [] | enabledFilter:true" style="border: 0.2pt solid grey; border-bottom: 0; border-top: 0; border-left: 0;" [style.border-color]=" val.colore ? 'black' : 'transparent'">
          <div class="d-flex flex-column align-items-center justify-content-center" >
            <input *ngIf="val.edit && permission.HasCapacity(['gestione-scorte'])" [(ngModel)]="val.value" (blur)="InputBlur(i, item)" style="min-width: 100px"  min="0" type="number" class="form-control">
            <span class="d-flex justify-content-center" style="margin-top: 5pt;" *ngIf="!val.edit || !permission.HasCapacity(['gestione-scorte'])"> {{val.value}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': val.colore ?? 'transparent'}" *ngIf="!val.edit || !permission.HasCapacity(['gestione-scorte'])"> &nbsp; </span>
          </div>
        </td>
      </ng-container>
    </tr>
    </tbody>
  </table>
</div>
  </div>
</div>
